import { createFileRoute } from "@tanstack/react-router";
import { DemoHome } from "@/pages/demo/DemoHome";

export const Route = createFileRoute("/demo/")({
  component: DemoHome,
});
